/** Figma PC frame content width (`94741:252458`). */
export const PORTFOLIO_GHOST_PC_CONTENT_MAX_WIDTH_PX = 768;

/** Figma H5/PC — link bar block height used for scroll spacer. */
export const PORTFOLIO_GHOST_LINK_BAR_HEIGHT_PX = 116;

/** Figma PC frame bottom inset (`94741:252458` py-[24px]). */
export const PORTFOLIO_GHOST_PC_BOTTOM_PADDING_PX = 24;

/** Figma PC `94741:253894` — fade mask above bottom link row. */
export const PORTFOLIO_GHOST_LINK_PC_FADE_HEIGHT_PX = 112;
